import React, { useContext } from 'react'

import { TodoCounter } from 'components/TimerApp/Todo/TodoCounter';
import { TodoSearch } from 'components/TimerApp/Todo/TodoSearch';
import { TodoItem } from 'components/TimerApp/Todo/TodoItem';
import { TodoList } from 'components/TimerApp/Todo/TodoList';
import { CreateTodoButton } from 'components/TimerApp/Todo/CreateTodoButton';
import { TodosLoading } from 'components/TimerApp/Todo/TodosLoading'
import { TodosError } from 'components/TimerApp/Todo/TodosError'
import { CreateFirstTodo } from 'components/TimerApp/Todo/CreateFirstTodo'

import { TodoContext } from 'contexts/TimerAppContexts/TodoContext';
import { Modal } from 'components/TimerApp/Todo/Modal';
import { TodoForm } from 'components/TimerApp/Todo/TodoForm';

import TodoFilter from 'components/TimerApp/Todo/TodoFilter';
import Confetti from 'react-confetti';
import { useWindowSize } from '../../hooks/useWindowSize';



const TimerAppUI = () => {
    const {width} = useWindowSize()
    const {
        loading,
        searchedTodos,
        error,
        completeTodo,
        deleteTodo,
        openModal,
        searchValue,
        filterTodos,
        allTodosCompleted,
    } = useContext(TodoContext);

    return (
        <div className="App">
            {searchedTodos.length > 0 && allTodosCompleted && <Confetti className='confetti' recycle={false} width={width}/>}
            <h1>Todos</h1>
            {allTodosCompleted ? <h2>No tienes TO-DO'S pendientes</h2> : <TodoCounter />}
            <TodoSearch />
            <TodoFilter />
            <TodoList>
                {loading && <TodosLoading />}
                {!loading && error && <TodosError />}
                {!loading && searchValue === '' && searchedTodos.length === 0 && <CreateFirstTodo />}
                {filterTodos.map(todo => (
                    <TodoItem
                        key={todo.key}
                        id={todo.key}
                        text={todo.text}
                        completed={todo.completed}
                        category={todo.category}
                        intensity={todo.intensity}
                        onComplete={() => completeTodo(todo.key)}
                        onDelete={() => deleteTodo(todo.key)}
                        totalPomodoros={todo.totalPomodoros}
                        completedPomodoros={todo.completedPomodoros}
                    />
                ))}
            </TodoList>
            <CreateTodoButton />
            {openModal && (
                <Modal>
                    <TodoForm />
                </Modal>
            )}
        </div>
    )
}

export { TimerAppUI }